import { GraphQLClient } from "graphql-request";

const DEFAULT_GRAPHQL_ENDPOINT = "https://cg.optimizely.com/content/v2";

export const GRAPHQL_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT ?? DEFAULT_GRAPHQL_ENDPOINT;

const GRAPHQL_AUTHORIZATION = process.env.NEXT_PUBLIC_GRAPHQL_AUTHORIZATION;
const GRAPHQL_API_KEY = process.env.NEXT_PUBLIC_GRAPHQL_API_KEY;
const GRAPHQL_SINGLE_KEY = process.env.GRAPHQL_SINGLE_KEY;

function createGraphQlClient(): GraphQLClient {
  const headers: Record<string, string> = {
    Accept: "application/json",
  };

  if (GRAPHQL_AUTHORIZATION) {
    headers.Authorization = GRAPHQL_AUTHORIZATION;
  }

  if (GRAPHQL_API_KEY) {
    headers["x-api-key"] = GRAPHQL_API_KEY;
  }

  if (GRAPHQL_SINGLE_KEY && !headers.Authorization && !headers["x-api-key"]) {
    headers.Authorization = `epi-single ${GRAPHQL_SINGLE_KEY}`;
  }

  return new GraphQLClient(GRAPHQL_ENDPOINT, {
    headers,
  });
}

let browserGraphQlClient: GraphQLClient | undefined;

export function getGraphQlClient(): GraphQLClient {
  if (globalThis.window === undefined) {
    return createGraphQlClient();
  }

  if (!browserGraphQlClient) {
    browserGraphQlClient = createGraphQlClient();
  }

  return browserGraphQlClient;
}
